import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.93934 0.93934C1.52513 0.353553 2.47487 0.353553 3.06066 0.93934L8 5.87868L12.9393 0.93934C13.5251 0.353553 14.4749 0.353553 15.0607 0.93934C15.6464 1.52513 15.6464 2.47487 15.0607 3.06066L10.1213 8L15.0607 12.9393C15.6464 13.5251 15.6464 14.4749 15.0607 15.0607C14.4749 15.6465 13.5251 15.6465 12.9393 15.0607L8 10.1213L3.06066 15.0607C2.47487 15.6465 1.52513 15.6465 0.93934 15.0607C0.353553 14.4749 0.353553 13.5251 0.93934 12.9393L5.87868 8L0.93934 3.06066C0.353553 2.47487 0.353553 1.52513 0.93934 0.93934Z",
		fill: "#5F7691"
	})
});
export default SvgClose;
